__webpack_require__.p = "https://sandbox.atenea.ai/nabu/";